import React from "react";
import { Fragment, useEffect, useState } from "react";
import { Row, Col, Form, Button, Radio, Checkbox, DatePicker, Upload } from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import "../../styles/user/user.css";
import { signupAPI } from "../../Config/API/user";
import { serverError } from "../../common/Alerts/serverError";
import {
  ROLES,
  ROLES_LIST,
  SPONSOR_TYPES_LIST,
  sponsorTypes
} from "../../Config/helpers/constants";
import { Formik } from "formik";
import InputTextField from "../../common/FormItem/InputTextField";
import { signUpValidations, sponsorSignUpValidations } from "../../Config/helpers/validations";
import dayjs from "dayjs";
import moment from "moment";
import { InboxOutlined } from "@ant-design/icons";

const Signup = () => {
  const { Dragger } = Upload;
  const [loading, setloading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isSponsor = searchParams.get("sponsor");

  const documentUploadProps = {
    name: "document",
    multiple: false,
    maxCount: 1,
    beforeUpload: () => false,
    accept: ".pdf,.jpg,.jpeg,.png"
  };

  const navigate = useNavigate();

  useEffect(() => {
    let role = JSON.parse(localStorage.getItem("userDetails"))?.role;
    role = String(role).toLowerCase();
    const token = localStorage.getItem("userToken");
    if (token && role) {
      if (role === ROLES.organizer) {
        navigate("/organizer");
      }

      if (role === ROLES.player) {
        navigate("/player");
      }

      if (role === ROLES.sponsor) {
        navigate("/sponsor");
      }
    }
  }, []);

  // handle submit signUp
  const onFinish = async (values) => {
    const {
      email,
      firstName,
      lastName,
      nickName,
      role,
      password,
      phoneNumber,
      documentVerification
    } = values;

    let payload = {
      email,
      firstName,
      lastName,
      nickName,
      password,
      phone: phoneNumber,
      primaryRole: isSponsor ? ROLES.sponsor : role,
      dob: values?.DOB ? JSON.stringify(dayjs(values?.DOB).format("YYYY-MM-DD")) : "",
      file:
        documentVerification &&
        documentVerification.fileList &&
        documentVerification.fileList.length > 0
          ? documentVerification.fileList[0]
          : undefined
    };
    if (isSponsor) {
      payload.isOrganization = values?.sponsorType === sponsorTypes.organization ? true : false;
      payload.organizationName = firstName;
      delete payload.firstName;
    }

    // append all keys one by one
    // Object.keys(payload).forEach((key) => {
    //   formData.append(key, payload[key]);
    // })

    let response;

    // convert all payload keys to formData
    const formData = new FormData();

    formData.append("email", email);
    formData.append("firstName", firstName);
    formData.append("lastName", lastName);
    formData.append("nickName", nickName);
    formData.append("password", password);
    formData.append("phone", phoneNumber);
    formData.append("primaryRole", isSponsor ? ROLES.sponsor : role);
    formData.append(
      "dob",
      values?.DOB ? JSON.stringify(dayjs(values?.DOB).format("YYYY-MM-DD")) : ""
    );

    if (isSponsor) {
      formData.append("file", documentVerification?.file);
      formData.append("isOrganization", values?.sponsorType === sponsorTypes.organization);
      formData.append("organizationName", firstName);
    }

    // Object.keys(payload).forEach((key) => {
    //   formData.append(key, payload[key]);
    // });
    console.log("*** payload final ", payload);
    console.log("*** formData ", formData);

    try {
      setloading(true);
      response = await signupAPI(formData);
      const data = await response.json();
      setloading(false);
      if (data.type === "success") {
        Swal.fire({
          title: "profile created successfully!",
          text: "Verification email has been sent to your email please check your inbox or spam folder",
          confirmButtonText: "Ok",
          allowOutsideClick: false,
          confirmButtonColor: "#0085FF"
        }).then(
          (result) => result.isConfirmed && navigate(isSponsor ? "/signin?sponsor=true" : "/signin")
        );
      }
      if (data.type === "emailExist") {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Email or phone number already exist",
          confirmButtonColor: "#0085FF",
          allowOutsideClick: false
        });
      }
    } catch (err) {
      console.log(err);
      setloading(false);

      serverError();
    }
  };

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    password: "",
    confirmPassword: "",
    role: ROLES.player,
    organizationName: "",
    sponsorType: "individual"
  };

  return (
    <Fragment>
      <Row
        style={{ paddingBottom: "2%", paddingTop: "40px", backgroundColor: "#F5F7F9" }}
        justify="center">
        <Col md={11}>
          <Row className="middleRowPadding justifycenter">
            <Link to="/">
              <img alt="logo" className="logouser" height="100px" src="/images/logo.png" />
            </Link>
          </Row>
          <Row className="downMiddleRowPadding justifycenter">
            <h1 className="gameFont">Join the Game!</h1>
          </Row>
          <Row className="insidePadding justifycenter">
            <h1 className="insideFont">Go inside the best gamers social network!</h1>
          </Row>
          <Row className="signinAs justifycenter">
            {isSponsor ? <h1>Sponsor Sign up</h1> : <h1>Sign up as</h1>}
          </Row>
          <Row className="buttonsPadding" style={{ justifyContent: "space-evenly" }}>
            <button className="socialMediaButtons">
              <img alt="google.png" height="22px" width="22px" src="/images/google.png"></img>
            </button>
            <button className="socialMediaButtons">
              <img alt="twitter.png" height="21px" width="28px" src="/images/twitter.png"></img>
            </button>
            <button className="socialMediaButtons">
              <img alt="facebook.png" height="24px" width="24px" src="/images/fb.png"></img>
            </button>
            <button className="socialMediaButtons">
              <img
                alt="discort.png"
                height="24px"
                width="24px"
                src="https://assets-global.website-files.com/6257adef93867e50d84d30e2/636e0a6a49cf127bf92de1e2_icon_clyde_blurple_RGB.png"></img>
            </button>
          </Row>
          <Row className="signInLink mt-5" justify="center">
            {!isSponsor ? (
              <p>
                Register as a Sponsor ?
                <Link
                  to="/register?sponsor=true"
                  onClick={() => setSearchParams("sponsor=yes")}
                  style={{ color: "#0085FF" }}>
                  {" "}
                  Sponsor Sign up
                </Link>
              </p>
            ) : (
              <p>
                Register as a player/organizer ?
                <Link
                  to="/register"
                  onClick={() => setSearchParams("")}
                  style={{ color: "#0085FF" }}>
                  {" "}
                  Signup
                </Link>
              </p>
            )}
          </Row>
        </Col>
        <Col md={12} className="signupContainer">
          <Row style={{ marginTop: "1rem", borderBottom: "0.5px solid #D9D9D9" }}>
            <Col span={24} className="signInCen">
              <h1>Create a new account</h1>
              <h2 style={{ color: "#646464" }}>It’s quick and easy.</h2>
            </Col>
          </Row>
          <Row
            justify="center"
            style={{ marginTop: "1rem", marginLeft: "1rem", marginRight: "1rem" }}>
            <Formik
              enableReinitialize
              initialValues={initialValues}
              validationSchema={
                isSponsor ? sponsorSignUpValidations() : signUpValidations(isSponsor)
              }
              onSubmit={onFinish}>
              {({
                handleChange,
                values,
                errors,
                touched,
                setFieldTouched,
                handleSubmit,
                setFieldValue,
                isValid,
                dirty
              }) => (
                <>
                  <Form
                    name="basic"
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                    onFinish={handleSubmit}>
                    <Row gutter={16}>
                      <Col span={24}>
                        {isSponsor && (
                          <Form.Item
                            label="Primary Role"
                            rules={[{ required: true }]}
                            style={{ lineHeight: "normal" }}
                            name="radio-group"
                            className="pt-2">
                            <Radio.Group
                              name="sponsorType"
                              value={values?.sponsorType}
                              onChange={(e) => setFieldValue("sponsorType", e.target.value)}
                              className="mt-2 mb-2">
                              {SPONSOR_TYPES_LIST.map((sponsor, index) => (
                                <Radio key={index} value={sponsor?.value}>
                                  {sponsor.label}
                                </Radio>
                              ))}
                            </Radio.Group>
                          </Form.Item>
                        )}
                      </Col>
                      <Col span={12}>
                        <InputTextField
                          name="firstName"
                          style={{ lineHeight: "normal" }}
                          placeholder="First Name"
                          required
                        />
                      </Col>
                      {values?.sponsorType !== sponsorTypes.organization && (
                        <Col span={12}>
                          <InputTextField
                            name="lastName"
                            placeholder="Last Name"
                            style={{ lineHeight: "normal" }}
                            required
                          />
                        </Col>
                      )}
                      <Col span={24}>
                        {!isSponsor && (
                          <Form.Item
                            label="Primary Role"
                            rules={[{ required: true }]}
                            style={{ lineHeight: "normal" }}
                            name="radio-group">
                            <Radio.Group
                              name="role"
                              value={values?.role}
                              onChange={handleChange}
                              className="mt-2 mb-2">
                              {ROLES_LIST.filter((role) => role?.value !== ROLES.sponsor).map(
                                (role, index) => (
                                  <Radio key={index} value={role?.value}>
                                    {role.label}
                                  </Radio>
                                )
                              )}
                            </Radio.Group>
                          </Form.Item>
                        )}
                      </Col>
                      <Col span={24}>
                        {values?.sponsorType !== sponsorTypes.organization && (
                          <Form.Item
                            required
                            label="Date of Birth"
                            help={touched?.DOB && errors?.DOB ? errors?.DOB : undefined}
                            validateStatus={touched?.DOB && errors?.DOB ? "error" : "success"}>
                            <DatePicker
                              className="playerDob"
                              name="DOB"
                              showToday
                              inputReadOnly
                              value={values?.DOB ? moment(values?.DOB) : undefined}
                              onChange={(value) => setFieldValue("DOB", value)}
                              onBlur={() => setFieldTouched("DOB", true)}
                              style={{ lineHeight: "normal" }}
                            />
                          </Form.Item>
                        )}
                      </Col>
                      <Col span={24}>
                        <InputTextField
                          name="email"
                          type="email"
                          placeholder="Enter your email"
                          hasFeedback
                          style={{ lineHeight: "normal" }}
                          required
                        />
                      </Col>
                      <Col span={24}>
                        <InputTextField
                          hasFeedback
                          required
                          placeholder="Enter your number"
                          name="phoneNumber"
                          addonBefore="+92"
                          className="inputnumber"
                          type="number"
                          style={{ lineHeight: "normal" }}
                        />
                      </Col>
                      <Col span={12}>
                        <InputTextField
                          hasFeedback
                          required
                          placeholder="Enter your password"
                          name="password"
                          type="password"
                          style={{ lineHeight: "normal" }}
                        />
                      </Col>
                      <Col span={12}>
                        <InputTextField
                          hasFeedback
                          required
                          placeholder="Enter your confirm password"
                          name="confirmPassword"
                          type="password"
                          style={{ lineHeight: "normal" }}
                        />
                        {isSponsor && (
                          <Form.Item
                            name="documentVerification"
                            label="Document Verification"
                            required
                            help={errors?.documentVerification}
                            validateStatus={errors?.documentVerification ? "error" : "success"}>
                            <Dragger
                              {...documentUploadProps}
                              onChange={(info) => {
                                setFieldValue("documentVerification", info);
                              }}>
                              <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                              </p>
                              <p className="ant-upload-text">
                                Click or drag file to this area to upload
                              </p>
                              <p className="ant-upload-hint">
                                Support for a single file upload. PDF, JPG, JPEG, PNG only.
                              </p>
                            </Dragger>
                          </Form.Item>
                        )}
                      </Col>
                    </Row>

                    {/* Form Bottom */}
                    <Row justify="center" className="mt-4">
                      <Col md={16} xs={20}>
                        <Checkbox
                          onChange={(e) => setFieldValue("termsAndConditions", e.target.checked)}
                          checked={values?.termsAndConditions}
                          value={values?.termsAndConditions}>
                          I agree to{" "}
                          <Link to="/" style={{ color: "#0085FF" }}>
                            terms & conditions
                          </Link>
                        </Checkbox>
                        <Checkbox style={{ marginLeft: "0px", marginTop: "2%" }}>
                          I’d like being informed about latest news and tips
                        </Checkbox>
                        <Button
                          className="signUpButton"
                          disabled={!(isValid && dirty)}
                          type="primary"
                          htmlType="submit"
                          loading={loading}>
                          Sign up
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </>
              )}
            </Formik>
          </Row>
          <Row className="signInLink" justify="center">
            <p>
              Do you already have an account?{" "}
              <Link
                to={isSponsor ? "/signin?sponsor=true" : "/signin"}
                style={{ color: "#0085FF" }}>
                Sign in
              </Link>
            </p>
          </Row>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Signup;
